import { joinClasses } from 'utils/componentStyles/style.utils';
import '../../../assets/weatherMaps.scss';

const WeatherMapWidgetLayout = ({
  layout,
  mapContent,
  informationContent,
  mapAriaLabel,
  informationAriaLabel,
  className,
  mapClassName,
  informationClassName,
  informationTabIndex,
}) => {
  const isSideBySide = layout === '2x1';

  return (
    <div
      className={joinClasses(
        'd-flex min-h-0 min-w-0 flex-grow-1 gap-2 overflow-hidden',
        isSideBySide ? 'flex-row' : 'flex-column',
        className,
      )}
      data-weather-map-widget-layout={layout}
    >
      <section
        aria-label={mapAriaLabel}
        className={joinClasses(
          'd-flex min-h-0 min-w-0',
          isSideBySide ? 'h-100 flex-grow-1' : 'w-100',
          mapClassName,
        )}
      >
        {mapContent}
      </section>

      {informationContent && (
        <aside
          aria-label={informationAriaLabel}
          className={joinClasses(
            'd-flex min-h-0 min-w-0 rounded-2 border',
            isSideBySide ? 'h-100' : 'w-100 flex-grow-1',
            informationClassName,
          )}
          tabIndex={informationTabIndex}
        >
          {informationContent}
        </aside>
      )}
    </div>
  );
};

export default WeatherMapWidgetLayout;
